import styled from 'styled-components';

export const Input = styled.input`
  border: 1px solid ${({theme}) => theme.colors.gray[400]};
  border-radius: 8px;

  padding: 12px 16px;
  font-weight: 400;
  font-size: 12px;

  outline: none;

  width: 100%;
  height: 100%;

  resize: none;
`;

export const Button = styled.button`
  position: absolute;
  right: -50px;
  transform: translate(-50%, -50%);
  top: 50%;

  font-weight: 400;
  font-size: 12px;

  color: ${({ theme }) => theme.colors.white};

  background: ${({ theme }) => theme.colors.orange.primary};
  border-radius: 4px;
  border: none;

  padding: 6px 10px;

  transition: 0.2s ease-in;

  &:hover {
    opacity: 0.8;
  }
`;

export const Container = styled.div`
  min-width: 500px;
  position: relative;
`;
